import React from 'react';

import { Box } from '@zillow/constellation';
import type { CSSObject } from 'styled-components';

interface ShimmerProps {
    borderRadius?: CSSObject['borderRadius'];
}

export const Shimmer: React.FC<ShimmerProps> = ({ borderRadius }) => (
    <Box
        sx={{
            'animationDuration': '1.5s',
            'animationFillMode': 'forwards',
            'animationIterationCount': 'infinite',
            'animationTimingFunction': 'linear',
            'backgroundImage': '$PropertyCard.loading.backgroundImage',
            'backgroundColor': '$PropertyCard.loading.backgroundColor',
            'backgroundRepeat': 'no-repeat',
            'backgroundSize': '100%',
            'height': '100%',
            'width': '100%',
            'position': 'relative',
            'borderRadius': borderRadius,
            '@keyframes shimmer': {
                '0%': {
                    backgroundPosition: '-600px 0',
                },
                '100%': {
                    backgroundPosition: '600px 0',
                },
            },
            'animationName': 'shimmer',
        }}
    />
);

Shimmer.defaultProps = {
    borderRadius: '$radii.lg',
};
